import { BaseResponseHttp } from './commons.model';
import { CallPlace } from '../../model/http/myActivity.model';
import {
  Actions,
  BooleanCons,
  NumberCons,
  StringConst,
} from '../../constants/const';
import { RecipeSettingsActions } from '../local/general.model';
import { InformationClinics } from '../local/information.clinics.model';
import { DirectionsType, DirectionsTypeCreate } from '../local/directions.type';
import { ResponsibleDoctorInfo, ResponsibleDoctors } from './NewSpecialty.model';

export interface IDeliveredDirectionsRes extends BaseResponseHttp {
  response: DeliveredDirections[];
}
export interface ITaxDataRes extends BaseResponseHttp {
  response: TaxData[];
}

export interface IMyProfileRes extends BaseResponseHttp {
  response: IMyProfile;
}
export interface IImagesReceiptRes extends BaseResponseHttp {
  response: IImagesReceipt[];
}
export interface IImagesReceiptPostRes extends BaseResponseHttp {
  response: string;
}
export class IPaymentCard extends BaseResponseHttp {
  response: PaymentsIdsWithCard;
  constructor() {
    super();
    this.response = new PaymentsIdsWithCard();
  }
}
export class PaymentsIdsWithCard {
  conektaCustomerId: string;
  oxxopayCustomerId: string;
  cards: PaymentCard[];
  constructor() {
    this.conektaCustomerId = StringConst.empty;
    this.oxxopayCustomerId = StringConst.empty;
    this.cards = [];
  }

}
export interface IGetComentsCardResponse extends BaseResponseHttp {
  response: ComentsCard;
}
export interface IImagesReceipt {
  id: number;
  cardCode: string;
  logoUrl: string;
  signatureUrl: string;
  profilePictureUrl: string;
}

export class DeliveredDirections {
  shippingAddressNickName: string;
  street: string;
  number: string;
  streetNumber: string;
  country: string;
  suburb: string;
  city: string;
  state: string;
  stateAbr: string;
  betweenStreets: string;
  references: string;
  zipCode: string;
  contact: string;
  phoneNumber: string;
  isDefault: boolean;
  etablishmentName: string;
  directionFull: string;
  directionFullSubmit: string;
  deliveryAddress: string[];
  isSelect: boolean;
  saveShippingCost: boolean;
  shippingCost: number;
  licenseResponsibleDoctor: string;
  responsibleDoctor: string;
  patientEmail: string;
  responsibleId: number;
  licenseNumber: string;
  doctorResponsibleName: string;
  constructor() {
    this.shippingAddressNickName = StringConst.empty;
    this.street = StringConst.empty;
    this.number = StringConst.empty;
    this.streetNumber = StringConst.empty;
    this.country = StringConst.empty;
    this.suburb = StringConst.empty;
    this.city = StringConst.empty;
    this.state = StringConst.empty;
    this.stateAbr = StringConst.empty;
    this.betweenStreets = StringConst.empty;
    this.references = StringConst.empty;
    this.zipCode = StringConst.empty;
    this.contact = StringConst.empty;
    this.phoneNumber = StringConst.empty;
    this.isDefault = BooleanCons.false;
    this.etablishmentName = StringConst.empty;
    this.directionFull = StringConst.empty;
    this.directionFullSubmit = StringConst.empty;
    this.deliveryAddress = [];
    this.isSelect = BooleanCons.false;
    this.saveShippingCost = BooleanCons.true;
    this.shippingCost = NumberCons.one;
    this.licenseResponsibleDoctor = StringConst.empty;
    this.responsibleDoctor = StringConst.empty;
    this.patientEmail = StringConst.empty;
    this.responsibleId = NumberCons.zero;
    this.licenseNumber = StringConst.empty;
    this.doctorResponsibleName = StringConst.empty;
  }
}
export class UpdateAddress {
  doctorId: string;
  addressId: string;
  addressType: DirectionsTypeCreate;
  zipCode: string;
  contact: string;
  state: string;
  city: string;
  neighborhood: string;
  street: string;
  number: string;
  phone: string;
  etablishmentName: string;
  betweenStreets: string;
  references: string;
  stateComplete: string;
  patientEmail: string;
  action: Actions;
  responsibleId: number;
  licenseNumber: string;
  doctorResponsibleName: string;
  constructor() {
    this.doctorId = StringConst.empty;
    this.addressId = StringConst.empty;
    this.addressType = DirectionsTypeCreate.default;
    this.zipCode = StringConst.empty;
    this.contact = StringConst.empty;
    this.state = StringConst.empty;
    this.city = StringConst.empty;
    this.neighborhood = StringConst.empty;
    this.street = StringConst.empty;
    this.number = StringConst.empty;
    this.phone = StringConst.empty;
    this.etablishmentName = StringConst.empty;
    this.betweenStreets = StringConst.empty;
    this.references = StringConst.empty;
    this.stateComplete = StringConst.empty;
    this.patientEmail = StringConst.empty;
    this.action = Actions.default;
    this.responsibleId = NumberCons.zero;
    this.licenseNumber = StringConst.empty;
    this.doctorResponsibleName = StringConst.empty;
  }
}
export class TaxData {
  invoiceDataNickName: string;
  email: string;
  zipCode: string;
  rfc: string;
  state: string;
  city: string;
  suburb: string;
  street: string;
  number: string;
  isDefault: boolean;
  isSelect: boolean;
  isNeedTaxData: boolean;
  taxDataFull: string;
  taxDataListFull: string[];
  cfdi: string;
  cfdiValue: string;
  cfdiDescription: string;
  stateAbr: string;
  taxRegimeCode: string;
  taxRegimeCodeDescription: string;
  invoicetype: string;
  constructor() {
    this.invoiceDataNickName = StringConst.empty;
    this.email = StringConst.empty;
    this.zipCode = StringConst.empty;
    this.rfc = StringConst.empty;
    this.state = StringConst.empty;
    this.city = StringConst.empty;
    this.suburb = StringConst.empty;
    this.street = StringConst.empty;
    this.number = StringConst.empty;
    this.isDefault = BooleanCons.false;
    this.isSelect = BooleanCons.false;
    this.isNeedTaxData = BooleanCons.false;
    this.taxDataFull = StringConst.empty;
    this.taxDataListFull = [];
    this.cfdi = StringConst.empty;
    this.cfdiValue = StringConst.empty;
    this.cfdiDescription = StringConst.empty;
    this.stateAbr = StringConst.empty;
    this.taxRegimeCode = StringConst.empty;
    this.taxRegimeCodeDescription = StringConst.empty;
    this.invoicetype = StringConst.empty;
  }
}

export class UpdateDataTax {
  doctorId: string;
  action: Actions;
  nickName: string;
  rfc: string;
  zipCode: string;
  state: string;
  country: string;
  city: string;
  suburb: string;
  street: string;
  number: string;
  email: string;
  cfdi: string;
  cfdiValue: string;
  cfdiDescription: string;
  stateAbr: string;
  taxRegimeCode: string;
  taxRegimeCodeDescription?: string;
  lastNickname: string;
  constructor() {
    this.email = StringConst.empty;
    this.cfdi = StringConst.empty;
    this.cfdiValue = StringConst.empty;
    this.cfdiDescription = StringConst.empty;
    this.stateAbr = StringConst.empty;
    this.doctorId = StringConst.empty;
    this.nickName = StringConst.empty;
    this.rfc = StringConst.empty;
    this.zipCode = StringConst.empty;
    this.action = Actions.default;
    this.state = StringConst.empty;
    this.country = StringConst.empty;
    this.city = StringConst.empty;
    this.suburb = StringConst.empty;
    this.street = StringConst.empty;
    this.number = StringConst.empty;
    this.taxRegimeCode = StringConst.empty;
    this.lastNickname = StringConst.empty;
  }
}
export class DirectionsAndTaxs {
  shippingAddressNickName: string;
  invoiceDataNickName: string;
  street: string;
  streetNumber: string;
  number: string;
  country: string;
  suburb: string;
  city: string;
  state: string;
  zipCode: string;
  contact: string;
  phoneNumber: string;
  isDefault: boolean;
  email: string;
  rfc: string;
  isFromDirections: boolean;
  betweenStreets: string;
  references: string;
  etablishmentName: string;
  stateAbr: string;
  cfdiValue: string;
  cfdiDescription: string;
  responsibleDoctor: string;
  licenseResponsibleDoctor: string;
  taxRegimeCode: string;
  taxRegimeCodeDescription: string;
  patientEmail: string;
  responsibleId: number;
  licenseNumber: string;
  doctorResponsibleName: string;
  constructor() {
    this.isFromDirections = false;
    this.betweenStreets = StringConst.empty;
    this.references = StringConst.empty;
    this.etablishmentName = StringConst.empty;
    this.stateAbr = StringConst.empty;
    this.cfdiValue = StringConst.empty;
    this.cfdiDescription = StringConst.empty;
    this.responsibleDoctor = StringConst.empty;
    this.licenseResponsibleDoctor = StringConst.empty;
    this.isDefault = BooleanCons.false;
    this.email = StringConst.empty;
    this.rfc = StringConst.empty;
    this.number = StringConst.empty;
    this.country = StringConst.empty;
    this.suburb = StringConst.empty;
    this.city = StringConst.empty;
    this.state = StringConst.empty;
    this.zipCode = StringConst.empty;
    this.contact = StringConst.empty;
    this.shippingAddressNickName = StringConst.empty;
    this.invoiceDataNickName = StringConst.empty;
    this.street = StringConst.empty;
    this.phoneNumber = StringConst.empty;
    this.streetNumber = StringConst.empty;
    this.taxRegimeCode = StringConst.empty;
    this.taxRegimeCodeDescription = StringConst.empty;
    this.patientEmail = StringConst.empty;
    this.responsibleId = NumberCons.zero;
    this.licenseNumber = StringConst.empty;
    this.doctorResponsibleName = StringConst.empty;
  }
}

export class IMyProfile {
  doctorAdvisers: IDoctorAdvisers[];
  shippingAddress: ShippingAddress;
  email: string;
  doctorName: string;
  professionalLicense: string;
  groupName: string;
  phone: string;
  doctorInitials?: string;
  phone2: string;
  defaultShipAddress: string;
  birthDate: Date;
  customerServiceWhatsappUrl: string;
  constructor() {
    this.doctorAdvisers = [new IDoctorAdvisers()];
    this.email = StringConst.empty;
    this.doctorName = StringConst.empty;
    this.professionalLicense = StringConst.empty;
    this.groupName = StringConst.empty;
    this.phone = StringConst.empty;
    this.phone2 = StringConst.empty;
    this.defaultShipAddress = StringConst.empty;
    this.shippingAddress = new ShippingAddress();
    this.birthDate = new Date();
    this.customerServiceWhatsappUrl = StringConst.empty;
  }
}
export class IDoctorAdvisers {
  name: string;
  initials?: string;
  lastName: string;
  middleName: string;
  email: string;
  phoneNumber: string;
  officePhoneExt: string;
  cellPhone: string;
  profilePictureUrl: string;
  line: string;
  slpCode: number;
  constructor() {
    this.name = StringConst.empty;
    this.lastName = StringConst.empty;
    this.email = StringConst.empty;
    this.phoneNumber = StringConst.empty;
    this.officePhoneExt = StringConst.empty;
    this.cellPhone = StringConst.empty;
    this.profilePictureUrl = StringConst.empty;
    this.middleName = StringConst.empty;
    this.line = StringConst.empty;
    this.slpCode = NumberCons.zero;
  }
}

export class ShippingAddress {
  betweenStreets: string;
  city: string;
  country: string;
  etablishmentName: string;
  isDefault: boolean;
  phoneNumber: string;
  references: string;
  shippingAddressNickName: string;
  state: string;
  stateAbr: string;
  street: string;
  streetNumber: string;
  suburb: string;
  zipCode: string;
  constructor() {
    this.street = StringConst.empty;
    this.streetNumber = StringConst.empty;
    this.suburb = StringConst.empty;
    this.city = StringConst.empty;
    this.state = StringConst.empty;
    this.stateAbr = StringConst.empty;
    this.zipCode = StringConst.empty;
    this.betweenStreets = StringConst.empty;
    this.country = StringConst.empty;
    this.etablishmentName = StringConst.empty;
    this.isDefault = false;
    this.phoneNumber = StringConst.empty;
    this.shippingAddressNickName = StringConst.empty;
    this.references = StringConst.empty;
  }
}

export class IReceiptSttingsData extends BaseResponseHttp {
  response: GetReceiptSettingData;
  constructor() {
    super();
    this.response = new GetReceiptSettingData();
  }
}

export class IResponsibleDoctorList extends BaseResponseHttp {
  response: ResponsibleDoctors[];
  constructor() {
    super();
    this.response = [];
  }
}

export class IResponsibleDoctorInfo extends BaseResponseHttp {
  response: ResponsibleDoctorInfo[];
  constructor() {
    super();
    this.response = [];
  }
}

export class GetReceiptSettingData {
  academicInfo: AcademicInfo[];
  prescriptionInfo: PrescriptionInfo[];
  signature: string;
  idResponsible: number;
  constructor() {
    this.academicInfo = [];
    this.prescriptionInfo = [];
    this.signature = StringConst.empty;
    this.idResponsible = NumberCons.zero;
  }
}

export class PrescriptionInfo {
  id: number;
  cardCode: string;
  cellPhone: string;
  doctorName: string;
  phoneNumber: string;
  zipCode: string;
  state: string;
  municipality: string;
  neighborhood: string;
  street: string;
  streetNumber: string;
  specialityGroup: string;
  prescriptionConsecutive: number;
  alias: string;
  isSelected: number;
  responsibleDoctor: string;
  licenseResponsibleDoctor: string;
  constructor() {
    this.id = 0;
    this.cardCode = StringConst.empty;
    this.doctorName = StringConst.empty;
    this.phoneNumber = StringConst.empty;
    this.zipCode = StringConst.empty;
    this.state = StringConst.empty;
    this.municipality = StringConst.empty;
    this.neighborhood = StringConst.empty;
    this.street = StringConst.empty;
    this.streetNumber = StringConst.empty;
    this.specialityGroup = StringConst.empty;
    this.prescriptionConsecutive = 0;
    this.alias = StringConst.empty;
    this.isSelected = 0;
    this.responsibleDoctor = StringConst.empty;
    this.licenseResponsibleDoctor = StringConst.empty;
    this.cellPhone = StringConst.empty;
  }
}

export class ComentsCard {
  clientIdOpenpay: string;
  constructor() {
    this.clientIdOpenpay = StringConst.empty;
  }
}
export class RecipeSettingsData {
  doctorName: string;
  speciality: string;
  academicInfo: AcademicInfo[];
  doctorId: string;
  addressId: string;
  zipCode: string;
  state: string;
  neighborhood: string;
  street: string;
  number: string;
  phone: string;
  municipality: string;
  action: Actions;

  constructor() {
    this.doctorName = StringConst.empty;
    this.speciality = StringConst.empty;
    this.academicInfo = [];
    this.doctorId = StringConst.empty;
    this.addressId = StringConst.empty;
    this.zipCode = StringConst.empty;
    this.state = StringConst.empty;
    this.neighborhood = StringConst.empty;
    this.street = StringConst.empty;
    this.number = StringConst.empty;
    this.phone = StringConst.empty;
    this.municipality = StringConst.empty;
    this.action = Actions.none;
  }
}
export class AcademicInfo {
  id: number;
  cardCode: string;
  degreeType: string;
  degreeName: string;
  license: string;
  institution: string;
  doctorName = StringConst.empty;
  isResponsible: boolean;
  responsibleLicenses: string[];
  constructor() {
    this.id = 0;
    this.cardCode = StringConst.empty;
    this.degreeType = StringConst.empty;
    this.degreeName = StringConst.empty;
    this.license = StringConst.empty;
    this.institution = StringConst.empty;
    this.doctorName = StringConst.empty;
    this.isResponsible = BooleanCons.false;
    this.responsibleLicenses = [];
  }
}
export class IImagesReceiptReq {
  doctorId: string;
  logoImage: string;
  logoNeedsUpdate: boolean;
  logoFormat: string;
  signatureImage: string;
  signatureNeedsUpdate: boolean;
  signatureFormat: string;
  signatureType: string;

  constructor() {
    this.doctorId = StringConst.empty;
    this.logoImage = StringConst.empty;
    this.logoNeedsUpdate = false;
    this.logoFormat = StringConst.empty;
    this.signatureImage = StringConst.empty;
    this.signatureNeedsUpdate = false;
    this.signatureFormat = StringConst.empty;
    this.signatureType = StringConst.empty;
  }
}

export class ISignatureResponsibleDcotor {
  cardCode: string;
  responsibleDoctorId: number;
  signatureImage: string;
  signatureFormat: string;
  signatureType: string;

  constructor() {
    this.cardCode = StringConst.empty;
    this.responsibleDoctorId = NumberCons.zero;
    this.signatureImage = StringConst.empty;
    this.signatureFormat = StringConst.empty;
    this.signatureType = StringConst.empty;
  }
}

export class IZipCodeResponse extends BaseResponseHttp {
  response?: ZipCodeDetail[];
}
export class ZipCodeDetail {
  id: number;
  city: string;
  neighborhood: string;
  zipcode: string;
  state: string;
  stateabr: string;

  constructor() {
    this.id = 0;
    this.city = StringConst.empty;
    this.neighborhood = StringConst.empty;
    this.zipcode = StringConst.empty;
    this.state = StringConst.empty;
    this.stateabr = StringConst.empty;
  }
}

export class UpdateDataTaxEstructor {
  dataUpdate: UpdateDataTax;
  place: CallPlace;
  action: Actions;

  constructor() {
    this.dataUpdate = new UpdateDataTax();
    this.place = CallPlace.default;
    this.action = Actions.none;
  }
}

export class IGetMyProfileInfoResponse extends BaseResponseHttp {
  response: GetMyProfileInfo;
  constructor() {
    super();
    this.response = new GetMyProfileInfo();
  }
}

export class IGetAilmentsList extends BaseResponseHttp {
  response: string[];
  constructor() {
    super();
    this.response = [];
  }
}

export class GetMyProfileInfo {
  infoClinics: InformationClinics[];
  doctorPersonalInfo: ProfileInfoForm[];
  constructor() {
    this.infoClinics = [];
    this.doctorPersonalInfo = [];
  }
}

export class ProfileInfoForm {
  phoneNumber: string;
  whatsapp: string;
  additionalPhone: string;
  facebookPage: string;
  twitterPage: string;
  instagramPage: string;
  birthDate: Date | null;
  doctorName: string;
  authorizedPersonnelName: string;
  authorizedPersonnelJob: string;
  authorizedPersonnelWhastApp: string;
  authorizedPersonnelBirthDay: Date | null;
  associationToWhichItBelongs: string;
  publicInstitutionWhichIProvideMyServices: string;
  socialNetworksWebSite: string;

  constructor() {
    this.phoneNumber = StringConst.empty;
    this.whatsapp = StringConst.empty;
    this.additionalPhone = StringConst.empty;
    this.facebookPage = StringConst.empty;
    this.twitterPage = StringConst.empty;
    this.instagramPage = StringConst.empty;
    this.birthDate = null;
    this.doctorName = StringConst.empty;
    this.authorizedPersonnelName = StringConst.empty;
    this.authorizedPersonnelJob = StringConst.empty;
    this.authorizedPersonnelWhastApp = StringConst.empty;
    this.authorizedPersonnelBirthDay = null;
    this.associationToWhichItBelongs = StringConst.empty;
    this.publicInstitutionWhichIProvideMyServices = StringConst.empty;
    this.socialNetworksWebSite = StringConst.empty;
  }
}

export enum TypeOfMethod {
  card = 'card',
  spei = 'bank_account',
  store = 'store',
  paypal = 'paypal',
  default = '',
}

export enum GuidIcon {
  DHL = 'dhl',
  SENDA = 'senda',
  TRES_GUERRAS = 'tres guerras',
  TDV = 'tdv',
  FEDEX = 'fedex',
}

export interface EditPaymentCard {
  cardCode: string;
}
export class PaymentCard {
  id: string;
  brand: string;
  cardNumber: string;
  holderName: string;
  expirationMonth: string;
  expirationYear: string;
  brandImag: string;
  creationDate?: string;
  isDefault?: string;
  cardId?: string;
  cvv?: string;
  isSelect?: boolean;
  isAddSelect?: boolean;
  comments?: string;
  typeOfMethod?: string;
  validDays?: number;
  bin?: string;
  cardType?: string;
  issuer?: string;
  monthlyInstallments?: number | null;
  monthlyAmount?: number | null;

  constructor() {
    this.cardId = StringConst.empty;
    this.id = StringConst.empty;
    this.brand = StringConst.empty;
    this.creationDate = StringConst.empty;
    this.isDefault = StringConst.empty;
    this.holderName = StringConst.empty;
    this.cardNumber = StringConst.empty;
    this.expirationYear = StringConst.empty;
    this.expirationMonth = StringConst.empty;
    this.cvv = StringConst.empty;
    this.brandImag = StringConst.empty;
    this.isSelect = BooleanCons.false;
    this.isAddSelect = BooleanCons.false;
    this.comments = StringConst.empty;
    this.typeOfMethod = TypeOfMethod.default;
  }
}
export class AddPaymentMethodEstructor {
  data: PaymentCard;
  place: CallPlace;
  action: Actions;
  noDefaultCard: boolean;
  cardListLength: number;
  constructor() {
    this.place = CallPlace.default;
    this.action = Actions.none;
    this.noDefaultCard = BooleanCons.false;
    this.cardListLength = NumberCons.zero;
    this.data = new PaymentCard();
  }
}

export interface CreatePaymentCard {
  tokenId: string;
  cardCode: string;
  doctorName?: string;
  email?: string;
  isSelected?: number;
  paymentCard: PaymentCard;
}
export interface DefaultPaymentCard {
  cardCode: string;
  cardDefaultId: string;
}

export interface DeletePaymentCard {
  cardCode: string;
  cardId: string;
}
export class RecipeAddress {
  doctorName: string;
  speciality: string;
  doctorId: string;
  addressId: string;
  zipCode: string;
  state: string;
  city: string;
  neighborhood: string;
  street: string;
  number: string;
  phone: string;
  etablishmentName: string;
  betweenStreets: string;
  references: string;
  action: RecipeSettingsActions;

  constructor() {
    this.doctorName = StringConst.empty;
    this.speciality = StringConst.empty;
    this.doctorId = StringConst.empty;
    this.addressId = StringConst.empty;
    this.zipCode = StringConst.empty;
    this.state = StringConst.empty;
    this.city = StringConst.empty;
    this.neighborhood = StringConst.empty;
    this.street = StringConst.empty;
    this.number = StringConst.empty;
    this.phone = StringConst.empty;
    this.etablishmentName = StringConst.empty;
    this.betweenStreets = StringConst.empty;
    this.references = StringConst.empty;
    this.action = RecipeSettingsActions.none;
  }
}

export class AddTaxDialogData {
  callPLace: CallPlace;
  data: DirectionsAndTaxs;
  action: Actions;
  typeDirection: DirectionsType;
  directionList: DirectionsAndTaxs[];
  constructor() {
    this.callPLace = CallPlace.default;
    this.action = Actions.none;
    this.data = new DirectionsAndTaxs();
    this.typeDirection = DirectionsType.doctor;
    this.directionList = [];
  }
}

export class RecipeSettingsObj {
  action: RecipeSettingsActions;
  address: DirectionsAndTaxs;

  constructor() {
    this.action = RecipeSettingsActions.none;
    this.address = new DirectionsAndTaxs();
  }
}

export class SaveLicense {
  id: number;
  cardCode: string;
  doctorName: string;
  degreeType: string;
  degreeName: string;
  license: string;
  institution: string;

  constructor() {
    this.id = 0;
    this.cardCode = StringConst.empty;
    this.doctorName = StringConst.empty;
    this.degreeType = StringConst.empty;
    this.degreeName = StringConst.empty;
    this.license = StringConst.empty;
    this.institution = StringConst.empty;
  }
}

export class SaveResponsibleDoctorLicense {
  degreeType: string;
  degreeName: string;
  licenseNumber: string;
  institution: string;
  responsibleDoctorId: number;
  constructor() {
    this.degreeType = StringConst.empty;
    this.degreeName = StringConst.empty;
    this.licenseNumber = StringConst.empty;
    this.institution = StringConst.empty;
    this.responsibleDoctorId = NumberCons.zero;
  }
}

export class UpdatePhotoInfo {
  existProfilePhoto: boolean;
  myHeaderProfile: IMyProfile;
  profilePhoto: string;
  callPlace: CallPlace;
  changeBoth: boolean;
  cardCode: string;
  isDoctorSelected: boolean;
  changePhoto: boolean;
  coverImage?: boolean;
  constructor() {
    this.existProfilePhoto = false;
    this.myHeaderProfile = new IMyProfile();
    this.profilePhoto = StringConst.empty;
    this.callPlace = CallPlace.default;
    this.changeBoth = false;
    this.cardCode = StringConst.empty;
    this.isDoctorSelected = false;
    this.changePhoto = false;
    this.coverImage = BooleanCons.false;
  }
}
export class OptionChangeData {
  isDefault: boolean;
  isSelected: boolean;
  isDirection: boolean;
  isTaxData: boolean;
  constructor() {
    this.isDefault = BooleanCons.false;
    this.isSelected = BooleanCons.false;
    this.isDirection = BooleanCons.false;
    this.isTaxData = BooleanCons.false;
  }
}

export class ConfirmDirectionAndHour {
  direction: DeliveredDirections;
  transationId: string;
  isLocal: boolean;
  isInstitucional: boolean;
  isFromOrders: boolean;
  comments: string;
  constructor() {
    this.direction = new DeliveredDirections();
    this.transationId = StringConst.empty;
    this.isLocal = false;
    this.isInstitucional = false;
    this.isFromOrders = false;
    this.comments = StringConst.empty;
  }
}

export class HoursRange {
  init: string;
  end: string;
  constructor() {
    this.init = '10:00';
    this.end = '18:00';
  }
}

export class TimeRange {
  hourRange: HoursRange;
  comments?: string;
  constructor() {
    this.hourRange = new HoursRange();
  }
}

export class SaveResponsibleDoctor {
  cardCode: string;
  name: string;
  degreeType: string;
  degreeName: string;
  licenseNumber: string;
  institution: string;

  constructor() {
    this.cardCode = StringConst.empty;
    this.name = StringConst.empty;
    this.degreeType = StringConst.empty;
    this.degreeName = StringConst.empty;
    this.licenseNumber = StringConst.empty;
    this.institution = StringConst.empty;
  }
}
export interface ResponsibleDoctorsResponse extends BaseResponseHttp {
  response: ResponsibleDoctorsDirection;
}
export class ResponsibleDoctorsDirection {
  responsibleDoctors: ResponsibleDoctorsList[] = [];
  defaultDirection: DeliveredDirections = new DeliveredDirections();
}

export class ResponsibleDoctorsList {
  name: string;
  id: number;
  licenseNumber: string;
  constructor() {
    this.name = StringConst.empty;
    this.id = NumberCons.zero;
    this.licenseNumber = StringConst.empty;
  }
}
